<template>
    <div>
        <div class="i-modal-mask i-class-mask i-modal-mask-show" v-if="visible"></div>
        <div class="i-class i-modal i-modal-show" v-if="visible">
            <div class="i-modal-main">
                <div class="i-modal-close" @click="close">
                    <van-icon name="cross" size="18" color="#999"/>
                </div>
                <div class="i-modal-content">
                    <div class="i-modal-title">手机号授权</div>
                    <van-field 
                     ref="mymobile"
                    v-model="tel" 
                    class="mymobile"
                    placeholder="请输入您的手机号码" 
                    maxlength="11" 
                    type="tel" 
                    :autofocus="true"
                    :border="false"
                    :clickable="true"
                    >
                        <template #button>
                            <div class="verification-code" v-show="!showCountDown" @click="sendCode">发送验证码</div>
                            <van-count-down :time="60000"
                                            millisecond
                                            ref="countDown"
                                            @finish="finish"
                                            v-show="showCountDown"
                                            :auto-start="false">
                                <template #default="timeData">
                                    <span class="block">{{ timeData.seconds||60 }}s</span>
                                </template>
                            </van-count-down>
                        </template>
                    </van-field>
                    <!-- 验证码输入框 -->
                    <van-password-input
                            :value="code"
                            :mask="false"
                            :focused="showKeyboard"
                            @focus="showKeyboard = true"
                    />
                    <!-- 数字键盘 -->
                    <van-number-keyboard
                            v-model="code"
                            :show="showKeyboard"
                            @blur="showKeyboard = false"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Icon ,Field,PasswordInput, NumberKeyboard,CountDown } from 'vant';
    export default {
        name: "authorize_mobile",
        props:{
            visible: {
                type:Boolean,
                default:false
            }
        },
        components:{
            [Icon.name]:Icon,
            [Field.name]:Field,
            [PasswordInput.name]:PasswordInput,
            [NumberKeyboard.name]:NumberKeyboard,
            [CountDown.name]:CountDown,
        },
        data(){
            return {
                tel:'',
                code:'',
                showKeyboard:false,
                showCountDown:false,
            }
        },
        watch:{
            code(value){
                var _self = this;
                if(value.length == 6){
                    if(this.tel == ''){
                        _self.code ='';
                        return this.util.showToast({
                            message:'手机号码不能为空'
                        })
                    }
                    if(!(/^1[3456789]\d{9}$/.test(this.tel))){
                        _self.code ='';
                        return this.util.showToast({
                            message:'请输入正确的手机号码'
                        })
                    }
                    this.util.server.mini_user.h5_bind_phone({
                        data:{
                            mobile:this.tel,
                            code:value
                        },
                        callback: (res =>{
                            const {code,data,msg} = res;
                            if(code == -1){
                                _self.code ='';
                                return false;
                            }

                            this.util.user_mobile.set(this.tel);
                            _self.visible=false;

                            _self.$emit('usergrantcallback',{is_grant:true});

                        })

                    })
                }
            }
        },
        methods:{
            focusMoblie(){
                console.log("focusMoblie")
                this.$refs.mymobile.focus()
            },
            close(){
                this.$emit('usergrantcallback',{is_grant:false});
            },
            sendCode(){
                if(!(/^1[3456789]\d{9}$/.test(this.tel))){
                    return this.util.showToast({
                        message:'请输入正确的手机号码'
                    })
                }
                const _self = this
                // 验证是否有双账号问题
                this.util.server.mini_user.check_mobile_bind({
                    data:{
                        mobile:this.tel
                    },
                    callback:(res =>{
                        const {code,data,msg} = res;
                        if(code == -1){
                            return
                        }
                        if(data.status==2){ 
                          // 当前用户已经绑定了其他用户，跳转合并账号,并设置需要返回的路径
                          _self.util.tempRedirect.set(location.href)
                          _self.$router.push(this.util.urlPrefix+'/user/merge?mobile='+_self.tel+'&token='+this.util.token)
                          return
                        }else if(data.status==1){
                          _self.util.showToast({
                              message:'您的手机号码已经绑定,正为您更新'
                          })
                          _self.visible=false;
                          _self.util.user_mobile.set(_self.tel);
                          return 
                        }else{
                          _self.sendLoginCode()
                        }
                    })
                })

                
            },
            finish(){
                this.showCountDown=false;
                this.$refs.countDown.reset();
            },
            sendLoginCode(){
                this.util.server.user.login_code({
                    data:{
                        mobile:this.tel
                    },
                    callback:(res =>{
                        const {code,data,msg} = res;
                        if(code == -1){
                            return
                        }

                        this.code='';
                        this.showKeyboard=true;
                        this.showCountDown=true;
                        this.$refs.countDown.start();
                    })
                })
            }
        }
    }
</script>

<style scoped>
    .i-modal {
        position:fixed;
        overflow:auto;
        top:0;
        right:0;
        bottom:0;
        left:0;
        height:100%;
        z-index:1000;
        display:flex;
        outline:0;
        -webkit-box-align:center;
        align-items:center;
        -webkit-box-pack:center;
        justify-content:center;
        transform:translateZ(1px);
        opacity:0;
        visibility:hidden
    }
    .i-modal-show {
        visibility:visible;
        opacity:1
    }
    .i-modal-mask {
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background:rgba(0, 0, 0, .7);
        z-index:1000;
        transition:all .2s ease-in-out;
        opacity:0;
        visibility:hidden
    }
    .i-modal-mask-show {
        opacity:1;
        visibility:visible
    }
    .i-modal-main {
        width:270px;
        position:relative
    }
    .i-modal-close{
        position: absolute;
        right: 10px;
        top: 7px;
        z-index: 1;
        font-size: 0;
    }
    .i-modal-content {
        border-radius:7px;
        padding-top:15px;
        position:relative;
        background-color:#fff;
        border:0;
        background-clip:padding-box;
        text-align:center;
        height:100%;
        overflow:hidden
    }
    .i-modal-body {
        max-height:100px;
        margin-bottom:15px;
        font-size:14px;
        color:#80848f;
        height:100%;
        line-height:1.5;
        overflow:auto
    }
    .i-modal-title {
        padding-top:6px;
        margin:0;
        font-size:16px;
        line-height:1;
        color:#1c2438;
        text-align:center
    }
    .verification-code{
        color: #ff6034;
        font-size: 12px;
    }
    .i-modal-content >>> .van-password-input__security{
        height: 34px;
    }
    .van-password-input{
        margin: 10px 16px;
    }
    .block{
        color: #999;
    }
    .mymobile >>> .van-field__control{
        background-color: rgba(226, 226, 226, 0.3);
        padding: 4px 6px;
    }
</style>
